<template>
	<div class="userListBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="back()">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">查看更多小仙女</p>
				</div>
			</div>
		</van-sticky>
		<div class="userList">
			<div class="userListItem" v-for="(item,index) in rankingList" :key="index">
				<div class="avatar"><img :src="$api.$BASE_URL_img + item.avatar" alt=""></div>
				<div class="nickname">{{index + 1}}.<span v-for="(it,idx) in item.nickname" v-if="idx > 8 ? false : true">{{it}}</span></div>
				<!-- 排行图标 -->
				<div class="db_img" v-if="item.sum_money <= 1">
					<img src="../../assets/img/lw_01.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 1 && item.sum_money <= 10">
					<img src="../../assets/img/lw_10.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 10 && item.sum_money <= 50">
					<img src="../../assets/img/lw_50.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 50 && item.sum_money <= 100">
					<img src="../../assets/img/lw_100.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 100 && item.sum_money <= 200">
					<img src="../../assets/img/lw_200.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 200 && item.sum_money <= 500">
					<img src="../../assets/img/lw_500.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 500 && item.sum_money <= 1000">
					<img src="../../assets/img/lw_1000.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 1000 && item.sum_money <= 5000">
					<img src="../../assets/img/lw_5000.png" alt="">
				</div>
				<div class="db_img" v-else-if="item.sum_money > 5000">
					<img src="../../assets/img/lw_5000.png" alt="">
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				rankingList:[],
			}
		},
		created(){
			if(this.$route.query.book_id){
				this.book_gift_rankingFn();
			}
			
		},
		methods:{
			back() {
				this.$router.go(-1);
			},
			book_gift_rankingFn (){
				if(localStorage.getItem('userInfoData')){
					this.$axios.post(this.$api.gift_ranking,{
						book_id: this.$route.query.book_id
					}).then(res => {
						if(res.data.code == 1){
							this.rankingList = res.data.data
						}else{
							this.$toast(res.data.msg);
						}
						
					})
				}else{
					this.$toast('请登录后查看')
				}
				
			}
			
		}
	}
</script>

<style lang="less" scoped>
	.userListBox{
		height: 100vh;
		background-color: #fff;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88%;
			background-size: 100%;
			background-color: #ffffff;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 70px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;
		
				
				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}
		
				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}
		
		}
		
		//用户列表
		.userList{
			background-color: #fff;
			.userListItem{
				display: flex;
				margin: 0 20px;
				position: relative;
				line-height: 120px;
				border-bottom: 1px solid #f0f0f0;/*no*/
				display: flex;
				flex-direction: row;
				align-items: center;
				
				.avatar{
					width:25%;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					
					img{
						width:60px;
						height:60px;
						border-radius: 50%;
					}
				}
				
				.nickname{
					display: inline-block;
					width:50%;
					text-align: center;
					font-size: 30px;/*px*/
					color: #202020;
				}
				.db_img{
					width:25%;
					display: flex;
					flex-direction: row;
					align-items: center;
					justify-content: center;
					
					img{
						width:80px;
					}
				}
				
			}
		}
		
	}

</style>
